import { get, derived, writable } from 'svelte/store';
import { loadSettings as _loadSettings } from '$lib/http/settings';
import constants from '$lib/constants';

export const settingsError = writable(false);
export const settingsLoaded = writable(false);
export const debtorSettings = writable({});
export const applicationTiles = writable([]);
export const permissions = writable([]);
export const userDebtors = writable([]);

export async function loadSettings() {
	try {
		const settings = await _loadSettings();
		return settings;
	} catch (err) {
		throw new Error(err);
	}
}

export const bookingTile = derived(applicationTiles, ($applicationTiles) => {
	return $applicationTiles.find((tile) => tile.type === constants.APP_TILE_TYPES.BOOKING);
});

export function hasPermission(permissionCode) {
	return get(permissions).some((p) => p.permissionCode === permissionCode);
}
